import { ActivatedRoute, RouterStateSnapshot, Router } from '@angular/router';
import { UserUtil } from './core/user-util';
import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpParams } from '@angular/common/http';
import { ToolbarService } from '@syncfusion/ej2-angular-documenteditor';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']

})

export class AppComponent implements OnInit {
  // title = 'app';
  clienteId = environment.pathImagens;

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      // private userUtil: UserUtil,
      private title: Title
			) {
    const url = window.location.href;
    let paramValue;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get("token");
    }
    if (paramValue) {
      router.navigate(['login'], {
        queryParams: {
          token: paramValue
        }
      });
    }
  }
  ngOnInit() {
    // this.userUtil.consultaSysdate();
    this.title.setTitle(this.clienteId);
    var imgSrc = `assets/img/sistema/${this.clienteId}/ecops.ico`;

    var link = document.createElement('link'),
    oldLink = document.getElementById('dynamic-favicon');
    link.id = 'dynamic-favicon';
    link.rel = 'shortcut icon';
    link.href = imgSrc;
    if (oldLink) {
      document.head.removeChild(oldLink);
    }
    document.head.appendChild(link);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts